import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
export var RadioInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var value = props.value,
      label = props.label,
      ariaLabel = props.ariaLabel,
      checked = props.checked,
      rest = _objectWithoutProperties(props, ["value", "label", "ariaLabel", "checked"]);

  var getClassName = getClassNameFactory(RadioInput.displayName);
  return /*#__PURE__*/React.createElement("label", {
    className: getClassName({
      descendantName: "label"
    }),
    htmlFor: value
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: getClassName({
      descendantName: "input"
    }),
    id: value,
    type: "radio",
    value: value,
    ref: ref,
    role: "radio",
    "aria-checked": checked,
    checked: checked
  }, rest)), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "labelText"
    }),
    "aria-label": ariaLabel
  }, " ", label));
});
RadioInput.displayName = "Form.RadioControl";